module.exports = __webpack_public_path__ + "static/media/report_6.e74ff9dd.jpg";